import { Pipe, PipeTransform } from '@angular/core';
import { IStringAnyMap } from 'lib-boox';

@Pipe({
  name: 'heroMenuApplications',
  standalone: true
})
export class HeroMenuApplicationsPipe implements PipeTransform {

  transform(applications: IStringAnyMap[], userApps : string[] = []): IStringAnyMap[] {
    console.log(userApps);
    return applications.filter((application: IStringAnyMap) => !!application['menu']);
  }

}
